export const BILLING_INFO_ACTION_TYPES = {
  initBillingInfoForm: 'initBillingInfoForm',
  setAddress: 'setAddress'
}

export const getDefaultPayApmInfo = () => {
  return {
    isApm: false,
    apmPaymentMethodId: '',
    apmPaymentMethodName: '',
    tileImageFileName: '',
    errorMessage: null,
    submitApm: false,
    apmCheckoutComplete: null,
    isDefaultPayment: false,
    blockSubmit: false,
    wiseStateValue: '',
    defaultWisePayment: ''
  }
}

export const getDefaultCvvReAuthInfo = () => {
  return {
    accountId: null,
    pmId: null,
    isCreditCardReAuthRequired: false
  }
}

export const getDefaultAddressInfoForCredit = () => {
  return {
    isSameAsContactSign: true,
    address1: '',
    address2: '',
    zip: '',
    city: '',
    state: '',
    country: ''
  }
}

export const getDefaultAddressInfo = () => {
  return {
    address1: '',
    address2: '',
    zip: '',
    city: '',
    state: '',
    country: '',
    countryId: '',
    phone: '',
    accountHq: '',
    companyName: '',
    employeeCount: '',
    usageType: '',
    countryName: '',
    vatNumber: '',
    notVatRegistered: false,
    doingBusinessAsName: '',
    businessType: '',
    otherBusinessType: ''
  }
}

export const CONTACT_TYPES = {
  BILLING_TO: 0,
  SOLD_TO: 1
}

export const EU_DISCLAIM_COUNTRIES = [
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
  'GB',
  'IS',
  'LI',
  'NO',
  'DE',
  'IM'
]
